import { ContainerItem } from 'ui/atoms';
import type { PageTab } from 'ui/templates';

interface Props {
  activeTab: number;
  tabs: PageTab[];
}

export const TabContent: React.FC<Props> = (props) => {
  const CurrentTab = props.tabs[props.activeTab]?.component;

  return <ContainerItem width="100%">{CurrentTab ? <CurrentTab /> : null}</ContainerItem>;
};
